import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface Props {
    cardId: string;
}

function CardSummary({ cardId }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { data } = useQuery(userPrepaidCardQueries.detail(cardId));

    if (!data) return null;

    return (
        <Wrapper>
            <Row spacing={4} align='center' fullWidth>
                <Image src={data.imageUrl}
                    width={90}
                    height={60}
                    alt={t('components.info.cardAlt')}
                    style={{ borderRadius: 8, objectFit: 'cover', aspectRatio: '3/2' }} />
                <Info>
                    <Text size='title' fontWeight='bold' multiline>
                        {data.name}
                    </Text>
                    <Text size='body-short' fontWeight='regular' multiline>
                        {t('log.balance', { amount: data.balance.toLocaleString() })}
                    </Text>
                </Info>
            </Row>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background-color: var(--color-white);
    padding: 16px;
    width: 100%;
`;

const Info = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export default CardSummary;
